import { Box, Button, Dialog, DialogContent, Divider, IconButton, ImageList, ImageListItem, ImageListItemBar, InputAdornment, MenuItem, TextField, Typography } from "@mui/material";

import { BoxFC, BoxFR } from "components/BoxCustom";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import PaperComponent from "components/PaperComponent";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import React, { useMemo, useState } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import dayjs from "dayjs";
import { useCallback } from "react";
import { alertConfirmDelete, alertError, alertWarning } from "components/Alert";
import { initDialogData } from "./initData";
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime";
import { fuelApiNm, fuelColNm } from "constants/FuelConstatn";
import ComboBox from "components/ComboBox";
import { CloudDownloadRounded, DeleteForeverRounded } from "resource/muiImport";
import { generateMenuComboItem } from "utils";
import FileDropOne from "components/FileUplaod/FileDropOne";
import { blue, blueGrey, lightGreen } from "@mui/material/colors";
import CheckboxFormControl from "components/CheckboxFormControl";

// const fuelFileTyp = [
//   { id: 1, label: "เลฃรถ" },
//   { id: 2, label: "เลขไมล์รถ" },
//   { id: 3, label: "จำนวนลิตร" },
//   { id: 4, label: "เลขไมลหัวจ่าย" },
//   { id: 5, label: "น้ำมัน" },
//   { id: 6, label: "อื่นๆ" },
// ]

// const initFileData = { file: null, label: "", fuelFileTypId: 1, imgLink: null }

let serverFiles = []
let originalDialogData = {}

const FuelDialog = ({ dialogOpen, setDialogOpen, onFinish, selectedId, lastFilter, fuelMaster }) => {

  const { ax, msData, setBadge } = useContext(GlobalStateContext)

  const [fuelFiles, setFuelFiles] = useState([])
  const [dialogData, setDialogData] = useState({ ...initDialogData })
  const [addFileData, setAddFileData] = useState()
  const [addFuelFileTypId, setAddFuleFileTypId] = useState(1)
  const [isCalMile, setIsCalMile] = useState(1)

  const accountCombo = useMemo(() => {
    const result = msData.driverCombo.map(item => ({ ...item, group: item.group === "บริษัท" ? "พนักงานขับรถ" : item.group }))
    const accounts = msData.accounts.filter(item => item.AccSts === 1)
    for (const account of accounts) {
      result.push({ id: account.AccId, label: account.NName, group: "พนักงาน" })
    }
    return result
  }, [msData])

  const fuelUnit = useMemo(() => {
    return dialogData.FuelTyp === "DSL" ? "ลิตร" : dialogData.FuelTyp === "GAS" ? "กก." : "kWh"
  }, [dialogData.FuelTyp])

  const datePickerProp = useCallback((name, isRequire) => ({
    disabled: dialogData.IsChk === 1 ? true : false,
    label: fuelColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: dialogData[name],
    onChange: (newValue) => { setDialogData(o => ({ ...o, [name]: newValue })) },
    renderInput: (params) =>
      <TextField size="small" onChange={null} {...params} required={isRequire} fullWidth error={!dialogData[name]} />,
  }), [dialogData, setDialogData,])

  const textFieldProp = useCallback((name, unit, align, isDefaultNull) => ({
    disabled: dialogData.IsChk === 1 ? true : false,
    variant: "outlined",
    size: "small",
    name: name,
    label: fuelColNm[name],
    value: dialogData[name] ?? "",
    fullWidth: true,
    onChange: (e) => {
      setDialogData(o => isDefaultNull ?
        ({ ...o, [name]: e.target.value === "" ? null : e.target.value })
        :
        ({ ...o, [name]: e.target.value })
      )
    },
    InputProps: unit && {
      endAdornment:
        <InputAdornment position="end">
          <Typography>{unit}</Typography>
        </InputAdornment>

    },
    inputProps: align == null ? {} : { style: { textAlign: align } }
  }), [dialogData])

  // const refreshImage = useCallback(() => {
  //   ax.post(fuelApiNm.getFuel, { FuelId: selectedId }).then(value => {
  //     if (value.data && value.data.length === 1) {
  //       setFuelFiles(value.data[0].FuelFiles)
  //     }
  //   })
  // }, [ax, selectedId])

  const handleSave = useCallback(async () => {
    let isPass = true
    if (dialogData.FuelTm === null || dialogData.DrvId === null) {
      alertError("กรุณาตรวจสอบข้อมูล")
      return;
    }

    let updateData = {}
    for (let key in dialogData) {
      if (dialogData[key] !== originalDialogData[key]) {
        updateData[key] = dialogData[key]
      }
    }
    let fuelId = selectedId
    if (Object.keys(updateData).length > 0) {
      const postData = {
        ...dialogData,
        withBadge: 1,
      }
      // let apiNm = selectedId ? fuelApiNm.updateFuelV2 : fuelApiNm.insertFuelV2
      let apiNm = ""
      if (selectedId) {
        postData.getArgs = lastFilter
        apiNm = fuelApiNm.updateFuelV2
      } else {
        postData.getArgs = null
        apiNm = fuelApiNm.insertFuelV2
      }
      const value = await ax.post(apiNm, postData)
      if (value.data) {
        if (selectedId) { // update retrun result forom lastFilter
          onFinish(value.data.data)
          setBadge(o => {
            const newData = { ...o, fuel: value.data.badgeNum }
            localStorage.setItem("badgeData", JSON.stringify(newData))
            return newData
          })
        } else {
          fuelId = value.data.data
          onFinish(null)
        }

      } else {
        isPass = false
      }


    }
    if (isPass) {
      setDialogOpen(false)
    }

    //find file in fuel file that not in serverFiles to add and delete
    const addFiles = fuelFiles.filter(file => !serverFiles.find(sFile => sFile.FuelFileId === file.FuelFileId))
    const delFiles = serverFiles.filter(sFile => !fuelFiles.find(file => file.FileNm === sFile.FileNm))



    for (const file of addFiles) {
      const data = new FormData();
      data.append("file", file.file);
      data.append("FuelId", fuelId);
      data.append("FuelFileTypId", file.FuelFileTypId);
      data.append("Label", file.Label);
      await ax.post(fuelApiNm.uploadFile, data)
    }
    for (const file of delFiles) {
      await ax.post(fuelApiNm.deleteFile, { FuelFileId: file.FuelFileId })
    }


  }, [ax, dialogData, lastFilter, setBadge, onFinish, setDialogOpen, selectedId, fuelFiles])

  const handleDelete = useCallback(() => {
    alertConfirmDelete(() => {

      const postData = {
        FuelId: selectedId,
        withBadge: 1,
        getArgs: lastFilter
      }
      ax.post(fuelApiNm.deleteFuel, postData).then(value => {
        if (value.data) {
          onFinish(value.data.data)
          setBadge(o => {
            const newData = { ...o, fuel: value.data.badgeNum }
            localStorage.setItem("badgeData", JSON.stringify(newData))
            return newData
          })
          setDialogOpen(false)
        }
      })
    })
  }, [selectedId, lastFilter, ax, onFinish, setBadge, setDialogOpen])


  const handleAddfile = useCallback(async () => {
    if (!addFileData) {
      alertError("กรุณาเลือกรูปภาพก่อน")
      return
    }
    const imgLink = URL.createObjectURL(addFileData)
    setFuelFiles(o => {
      const results = [1, 2, 3, 4, 5].includes(addFuelFileTypId) ?
        o.filter(file => file.FuelFileTypId !== addFuelFileTypId)
        : o.map(file => ({ ...file }))
      results.push({
        file: addFileData,
        FuelFileTypId: addFuelFileTypId,
        Label: fuelMaster.fuelFileTypeCombo.find(item => item.id === addFuelFileTypId)?.label || "",
        imgLink: imgLink,
        linkUrl: `/image/${imgLink.replaceAll("/", "~")}`
      })
      setAddFileData(null)
      setAddFuleFileTypId(o => o + 1)
      return results
    })

  }, [addFileData, addFuelFileTypId, fuelMaster.fuelFileTypeCombo])


  const handleDeleteImage = useCallback((fuelFileId) => () => {
    setFuelFiles(o => o.filter(file => file.FuelFileId !== fuelFileId))
  }, [])

  const handleSelectTruck = useCallback((value) => {
    const truck = msData.trucks.find(item => item.TukId === value)

    setDialogData(o => ({
      ...o,
      TukId: value,
      MileAdjPrct: truck?.MileAdj || 0,
      FuelTyp: truck?.IsGas === 0 ? "DSL" : truck?.IsGas === 1 ? "GAS" : "ELE",
      GenId: null
    }))
  }, [msData.trucks])

  const handleSelectGen = useCallback((value) => {
    setDialogData(o => ({ 
      ...o, 
      GenId: value, 
      FuelTyp: "DSL",
      TukId: null 
    }))
  }, [])
  const handleMileStnEnBlur = useCallback((e) => {
    setDialogData(o => {
      const value = e.target.value
      if (o.Litr && value) {
        return { ...o, MileStnSt: value - Math.round(o.Litr) }
      }
      else return o
    })
  }, [])

  const handleLitrBlur = useCallback((e) => {
    setDialogData(o => {
      const value = e.target.value
      if (o.MileStnEn && value) {
        return { ...o, MileStnSt: o.MileStnEn - Math.round(value) }
      }
      else return o
    })
  }, [])

  const handleAmntBlur = useCallback((e) => {
    setDialogData(o => {
      const value = e.target.value
      if (o.Litr && value) {
        return { ...o, FuelPr: (value / o.Litr).toFixed(2) }
      } else {
        return { ...o, FuelPr: null }
      }
    })
  }, [])

  const handleFuelPrBlur = useCallback((e) => {
    setDialogData(o => {
      const value = e.target.value
      if (o.Litr && value) {
        return { ...o, Amnt: (value * o.Litr).toFixed(2) }
      } else {
        return { ...o, Amnt: '' }
      }
    })
  }, [])

  const handleGetMileStnSt = useCallback(() => {
    if (!dialogData.FuelTm) {
      alertError("กรุณาใส่เวลาเติมก่อน")
      return
    }
    const postData = {
      StnId: dialogData.StnId,
      FuelTm: dayjs(dialogData.FuelTm).format("YYYY-MM-DD HH:mm:ss")
    }
    ax.post(fuelApiNm.getLastMileStnEn, postData).then(value => {
      setDialogData(o => ({ ...o, MileStnSt: value.data || 0 }))
    })
  }, [ax, dialogData.FuelTm, dialogData.StnId])

  const handleGetFuelPr = useCallback(() => {
    if (!dialogData.FuelTm) {
      alertError("กรุณาใส่เวลาเติมก่อน")
      return
    }

    if (dialogData.FuelTyp !== "DSL") {
      alertWarning("ราคาน้ำมันอัตโนมัติใช้ได้เฉพาะน้ำมันท่านั้น")
      return
    }

    const postData = {
      FuelDte: dayjs(dialogData.FuelTm).format("YYYY-MM-DD")
    }
    ax.post("/core/getFuelPriceByDate", postData).then(value => {
      if (value.data) {
        setDialogData(o => ({
          ...o,
          FuelPr: value.data || 0,
          Amnt: o.Litr ? (+value.data * +o.Litr) : o.Amnt
        }))
      }
    })
  }, [ax, dialogData.FuelTyp, dialogData.FuelTm])

  const handleGetMileTukSt = useCallback(() => {
    if (!dialogData.FuelTm || (!dialogData.TukId && !dialogData.GenId)) {
      alertError("กรุณาใส่เวลาเติม และเลขรถก่อน")
      return
    }
    const postData = {
      TukId: dialogData.TukId,
      GenId: dialogData.GenId,
      FuelTm: dayjs(dialogData.FuelTm).format("YYYY-MM-DD HH:mm:ss")
    }
    ax.post(fuelApiNm.getLastMileTukEn, postData).then(value => {
      setDialogData(o => ({ ...o, MileTukSt: value.data || 0 }))
    })
  }, [ax, dialogData.FuelTm, dialogData.TukId, dialogData.GenId])

  const handleStnIdChange = useCallback((e) => {
    setDialogData(o => ({ ...o, StnId: e.target.value }))
    const found = fuelMaster.fuelStnCombo.find(item => +item.id === +e.target.value)
    if (found) {
      setIsCalMile(found.IsCalMile)

      if (found.IsCalMile === 0) {
        setDialogData(o => ({ ...o, MileStnSt: null, MileStnEn: null }))
      }
    }
  }, [fuelMaster.fuelStnCombo])


  useEffect(() => {
    if (dialogOpen) {
      const found = fuelMaster.fuelStnCombo.find(item => +item.id === 1)
      if (found) {
        setIsCalMile(found.IsCalMile)
      }
      if (selectedId) {

        ax.post(fuelApiNm.getFuel, { FuelId: selectedId }).then(value => {
          if (value.data && value.data.length === 1) {

            // const linkUrl = `/image/${src.replaceAll("/", "~")}`
            serverFiles = value.data[0].FuelFiles.map(file => {

              const imgLink = `/file/fuel/${selectedId}/${file.FileNm}`

              return {
                ...file,
                // imgLink: imgLink,
                linkUrl: `/image/${imgLink.replaceAll("/", "~")}`
              }
            })
            setFuelFiles(serverFiles.map(item => item))
            delete value.data[0].FuelFiles
            originalDialogData = { ...value.data[0] }
            setDialogData({ ...originalDialogData })
          }
        })
      } else {
        setDialogData({ ...initDialogData })
        setFuelFiles([])
      }

    } else {
      setAddFuleFileTypId(1)
      setDialogData(initDialogData)
      setFuelFiles([])
      serverFiles = []
      setAddFileData(null)
    }
  }, [ax, selectedId, dialogOpen, fuelMaster.fuelStnCombo])


  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      PaperProps={{
        style: {
          minWidth: 1800,
          maxWidth: 1800,
          height: 870
        }
      }} >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={`รูปภาพ (${fuelFiles.length} รูป)`}
        onDeleteClick={handleDelete}
      />
      <DialogContent>
        <BoxFR sx={{ alignItems: "stretch", pt: 2, height: "100%" }}>
          <BoxFC sx={{ gap: 1 }} width={380}>
            <Typography variant="h6">ข้อมูลการเติมเชื้อเพลิง</Typography>
            <BoxFR>
              <TextField value={dialogData.StnId} label="เลขหัวจ่าย" select size="small" fullWidth
                disabled={dialogData.IsChk === 1 ? true : false}
                onChange={handleStnIdChange}>
                {generateMenuComboItem(fuelMaster.fuelStnCombo)}
              </TextField>
            </BoxFR>
            <BoxFR>

              <DateTimePickerCustomTime {...datePickerProp("FuelTm", true)} />
              <ComboBox options={accountCombo} label="ผู้เติมน้ำมัน" sx={{ width: "100%" }}
                disabled={dialogData.IsChk === 1 ? true : false}
                required={true}
                selectedId={dialogData.DrvId}
                setSelectedId={(value) => setDialogData(o => ({ ...o, DrvId: value }))}
              />
            </BoxFR>
            <BoxFR>
              <ComboBox options={msData.truckCombo} label="เลขรถ" sx={{ flex: 1 }}
                disabled={dialogData.IsChk === 1 ? true : false}
                selectedId={dialogData.TukId}
                setSelectedId={handleSelectTruck}
              />
              <ComboBox options={msData.genCombo} label="เลขเครื่อง Gen" sx={{ flex: 1 }}
                disabled={dialogData.IsChk === 1 ? true : false}
                selectedId={dialogData.GenId}
                setSelectedId={handleSelectGen}
              />
            </BoxFR>
            <BoxFR>
              <TextField  {...textFieldProp("MileTukSt", null, null, true)} type="number"
                label={dialogData.GenId ? "เลขไมล์ Gen ก่อนหน้า" : "เลขไมล์รถก่อนหน้า"}
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    <IconButton sx={{ p: 0 }} onClick={handleGetMileTukSt} disabled={dialogData.IsChk === 1 ? true : false}>
                      <CloudDownloadRounded fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                }} />
              <TextField  {...textFieldProp("MileTukEn", null, null, true)} type="number" 
                label={dialogData.GenId ? "เลขไมล์เครื่อง Gen" : "เลขไมล์รถ"}/>
            </BoxFR>

            <BoxFR>
              <TextField  {...textFieldProp("MileStnSt", null, null, true)}
                disabled={isCalMile === 1 && dialogData.IsChk === 0 ? false : true} type="number"
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    <IconButton sx={{ p: 0 }} disabled={isCalMile === 1 && dialogData.IsChk === 0 ? false : true}
                      onClick={handleGetMileStnSt}>
                      <CloudDownloadRounded fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                }} />

              <TextField  {...textFieldProp("MileStnEn", null, null, true)}
                disabled={isCalMile === 1 && dialogData.IsChk === 0 ? false : true} type="number" onBlur={handleMileStnEnBlur} />

            </BoxFR>
            <BoxFR>
              <TextField  {...textFieldProp("FuelTyp", null, null, true)} select>
                <MenuItem value="DSL">น้ำมัน</MenuItem>
                <MenuItem value="GAS">แก๊ส</MenuItem>
                <MenuItem value="ELE">ไฟฟ้า</MenuItem>
              </TextField>
              <TextField  {...textFieldProp("Litr", fuelUnit, "right", true)} type="number"
                label={`จำนวน (${fuelUnit})`} onBlur={handleLitrBlur} />
            </BoxFR>
            <BoxFR>
              <TextField  {...textFieldProp("FuelPr", <BoxFR
              ><IconButton sx={{ p: 0 }} disabled={dialogData.IsChk === 0 ? false : true}
                onClick={handleGetFuelPr}>
                  <CloudDownloadRounded fontSize="small" />
                </IconButton></BoxFR>, "right", true)} type="number"
                onChange={e => setDialogData(o => ({
                  ...o, FuelPr: e.target.value === "" ? null : e.target.value
                }))} onBlur={handleFuelPrBlur} />
              <TextField  {...textFieldProp("Amnt", "บาท", "right", true)} type="number" onBlur={handleAmntBlur} />
            </BoxFR>

            <BoxFR>
              <TextField  {...textFieldProp("MileAdjPrct", "%", "right", false)} type="number"
                value={dialogData.MileAdjPrct || 0}
                onChange={(e) => setDialogData(o => ({ ...o, MileAdjPrct: e.target.value || 0 }))}
              />
              <TextField  {...textFieldProp("MileAdjKm", "กม.", "right", false)} type="number"
                value={dialogData.MileAdjKm || 0}
                onChange={(e) => setDialogData(o => ({ ...o, MileAdjKm: e.target.value || 0 }))}
              />
            </BoxFR>


            <TextField  {...textFieldProp("Rmk", null, null, false)} disabled={false} multiline rows={4} />

            <Box p={2}
              bgcolor={dialogData.IsChk ? lightGreen[100] : null}
              border={1}
              borderColor={dialogData.IsChk ? lightGreen[500] : blue[500]}
              borderRadius={1}  >
              <CheckboxFormControl label="ข้อมูลถูกต้อง" checked={dialogData.IsChk === 1 ? true : false}
                onChange={(e) => setDialogData(o => ({ ...o, IsChk: e.target.checked ? 1 : 0 }))} />
            </Box>
          </BoxFC>
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
          <BoxFC flex={1} sx={{ gap: 0 }} height="100%">
            <BoxFR>

              {/* <Button variant="contained" component="label">
                <input type="file" hidden onChange={handleSelectFile} />
                เลือกรูปภาพ
              </Button> */}
              <BoxFR>
                <Typography fontWeight="bold">เพิ่มรูปภาพ:</Typography>
                <FileDropOne sx={{ width: 200 }} fileData={addFileData} setFileData={setAddFileData} />
              </BoxFR>
              <TextField value={addFuelFileTypId} label="ประเภทรูปภาพ" select size="small" sx={{ width: 180 }}
                onChange={(e) => { setAddFuleFileTypId(e.target.value) }}>
                {generateMenuComboItem(fuelMaster.fuelFileTypeCombo)}
              </TextField>
              <Button variant="contained" onClick={handleAddfile}>
                เพิ่มรูปภาพ
              </Button>
            </BoxFR>
            <ImageList cols={4} rowHeight={500} sx={{ width: "100%", flex: 1, bgcolor: blueGrey[50] }}>
              {fuelFiles.map(file => {


                return (
                  <ImageListItem key={file.FileNm} sx={{ position: "relative" }} >
                    <img alt={file.Label} src={file.imgLink} loading="lazy"
                      onClick={() => window.open(file.linkUrl)} style={{ height: 600 }} />
                    <ImageListItemBar
                      title={`${file.Label}`}
                      subtitle={
                        <BoxFC sx={{ gap: 0.5 }}>
                          <span>by: {file.NName} {dayjs(file.ModDte).format("DD/MM/YYYY HH:mm")}</span>
                        </BoxFC>
                      }
                      actionIcon={
                        <IconButton onClick={handleDeleteImage(file.FuelFileId)}>
                          <DeleteForeverRounded sx={{ m: 1, color: "white" }} />
                        </IconButton>
                      }
                    />
                  </ImageListItem>
                )
              })}
            </ImageList>
          </BoxFC>
        </BoxFR>
        {/* <BoxFC mt={2} sx={{ gap: 0 }}>

          
          <Divider />
          <BoxFR mt={2}>

          </BoxFR>
          <SaveButton onClick={handleSave} sx={{ mt: 1, width: 300, alignSelf: "flex-end" }} />
        </BoxFC> */}
      </DialogContent>
      <DialogFooter okText="บันทึก"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={onFinish? handleSave: null} />
    </Dialog>
  )
}

export default React.memo(FuelDialog)